import { styled } from "@mui/material/styles"

import { Skeleton as UiSkeleton, Typography } from "@l2r-front/l2r-ui"

export const Container = styled("div")({
    position: "relative",
    height: "100%",
    width: "100%",
})

export const ViewerWrapper = styled("div", {
    shouldForwardProp: (prop) => prop !== "$hidden",
})(({ hidden }) => ({
    height: "100%",
    width: "100%",
    visibility: hidden ? "hidden" : "visible",
}))

export const DateContainer = styled("div")(({ theme }) => ({
    position: "absolute",
    bottom: 0,
    right: 0,
    backgroundColor: "black",
    borderTopLeftRadius: 4,
    padding: theme.spacing(0, 2),
    zIndex: 91,
}))

export const DateLabel = styled(Typography)(({ theme }) => ({
    color: theme.palette["primary"].main,
}))

export const LoadingContainer = styled("div")(({ theme }) => ({
    backgroundColor: theme.palette["secondary"].light,
    position: "absolute",
    top: 0,
    height: "100%",
    width: "100%",
    zIndex: 90,
}))

export const Skeleton = styled(UiSkeleton)({
    height: "100%",
    transform: "scale(1)",
    width: "100%",
})

export const ErrorMessage = styled(Typography)({
    fontSize: 21,
})

export const ErrorContainer = styled("div")(({ theme }) => ({
    position: "absolute",
    top: 0,
    left: 0,
    backgroundColor: theme.errorBackground,
    width: "100%",
    height: "100%",
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    padding: "10px",
    zIndex: 90,
}))